import Header from '../../../../components/Header';
import Footer from '../../../../components/Footer/Footer';
import { MMANavbar } from '../../../../components/Tools/Navbar/Navbar';
import { Breadcrumb, Tab, Tabs, Table } from 'react-bootstrap';
import { FaHome } from 'react-icons/fa';
import Main from '../assets/equipment/3.1-main.png';
import InspectionFrame from '../assets/equipment/3.2-typical-safety-barrier.png';
import CellFrame from '../assets/equipment/3.3-barrier-locations.png';
import CameraMountAssembly from '../assets/equipment/3.4-frame-assembly-cameras.png';
import CameraMountAssembly2 from '../assets/equipment/3.5-frame-assembly-cameras-2.png';
import Camera201 from '../assets/equipment/3.6-camera-set-201.png';
import ParallelClamp from '../assets/equipment/3.7-parallel-vertical-frame-clamp.png';
import ParallelClamp2 from '../assets/equipment/3.7-parallel-vertical-frame-clamp-2.png';
import ParallelClamp3 from '../assets/equipment/3.7-parallel-vertical-frame-clamp-3.png';
import CameraAssembly from '../assets/equipment/3.8-camera-assembly.png';
import AlliedVision from '../assets/equipment/3.9-allied-vision-alvium-g5.png';
import Single600Lights from '../assets/equipment/3.10-600-single-lights.png';
import Double700Lights from '../assets/equipment/3.11-700-double-lights.png';

import 'bootstrap/dist/css/bootstrap.min.css';

const WarrenAssemblies = () => {
	return (
		<>
			<Header plant="montgomery" />
			<main>
				<wrapper class="section-wrapper">
					<MMANavbar />
					<container class="section-container">
						<Breadcrumb>
							<Breadcrumb.Item href="/smart-inspect/montgomery/overview">
								<FaHome size={20} />
							</Breadcrumb.Item>
							<Breadcrumb.Item active>Equipment</Breadcrumb.Item>
							<Breadcrumb.Item active>Assemblies</Breadcrumb.Item>
						</Breadcrumb>
						<content class="section-content">
							<Tabs defaultActiveKey="Inspection Frame Assembly" className="mb-3">
								<Tab eventKey="Inspection Frame Assembly" title="Inspection Frame Assembly">
									<div class="tab-section" style={{ display: 'flex' }}>
										<div class="left-side">
											<h2>INSPECTION FRAME ASSEMBLY</h2>
											<p>The cell uses structural welded beams to support the camera and lighting assemblies. The overall framework is covered by the Cell Frame Covering (vinyl panels) to protect the camera equipment and shield personnel from the bright LED lighting during scan sequences. The system is protected by windowed barriers.</p>
											<div class="d-flex justify-content-between">
												<figure style={{ textAlign: 'center' }}>
													<img src={InspectionFrame} alt="Master Key Box" style={{ width: '55vh' }} />
													<figcaption>Figure 1: Cell Frame Cover</figcaption>
												</figure>
												<figure style={{ textAlign: 'center' }}>
													<img src={Main} alt="Master Key Box" style={{ width: '35vh' }} />
													<figcaption>Figure 2: Main Frame Assembly Model</figcaption>
												</figure>
											</div>
										</div>

										<div class="right-side">
											<figure>
												<img src={CellFrame} alt="Master Key Box" style={{ width: '35vw' }} />
												<figcaption> Figure 3: Frame Assembly</figcaption>
											</figure>
										</div>
									</div>
								</Tab>

								<Tab eventKey="Camera Mounting Assemblies" title="Camera Mounting Assemblies">
									<div class="tab-section" style={{ display: 'flex', justifyContent: 'space-between' }}>
										<div class="left-side" style={{ width: '50vw' }}>
											<h2>CAMERA MOUNTING ASSEMBLIES</h2>
											<p>The cameras are mounted on prefabricated extruded metal channels assembled to precisely align each camera lens to their intended targets.</p>
											<p>Cameras are grouped in 16mm, 25mm, and 35mm Focal Length sets mounted on octagonal booms using transition brackets. These are then mounted on perpendicular, parallel, and vertical Frame Clamp Assemblies using similar components and finally mounted to the Frame Assembly with square tubular frame clamps.</p>

											<figure>
												<img src={CameraMountAssembly2} alt="Master Key Box" style={{ width: '30vw' }} />
												<figcaption>Figure 1: Frame Assembly Camera/Lighting – Part Going View</figcaption>
											</figure>
										</div>

										<div class="right-side">
											<p>NOTE: Main Frame Structure is shown for examples, Tail Gate Structure utilizes similar components.</p>
											<div class="img-box" style={{ display: 'flex', flexWrap: 'wrap' }}>
												<figure style={{ margin: '10px' }}>
													<img src={CameraMountAssembly} alt="Master Key Box" style={{ width: '18vw', margin: '0 auto', display: 'block' }} />
													<figcaption>Figure 2: Frame Assembly Camera/Lighting – Part Going View</figcaption>
												</figure>
												<figure style={{ margin: '5px 20px' }}>
													<img src={Camera201} alt="Master Key Box" style={{ width: '21vw', margin: '0 auto', display: 'block' }} />
													<figcaption>Figure 3: Main Frame Camera Set 9</figcaption>
												</figure>
												<figure style={{ margin: '10px' }}>
													<img src={ParallelClamp} alt="Master Key Box" style={{ width: '18vw', margin: '0 auto', display: 'block' }} />
													<figcaption>Figure 4: Main Frame Top Set Supports Frame Clamp Assembly Example</figcaption>
												</figure>
												<figure style={{ margin: '10px' }}>
													<img src={ParallelClamp2} alt="Master Key Box" style={{ width: '9vw', margin: '0 auto', display: 'block' }} />
													<figcaption>Figure 5: Parallel and Vertical (RH & LH) Clamp Assembly Example</figcaption>
												</figure>
												<figure style={{ margin: '10px' }}>
													<img src={ParallelClamp3} alt="Master Key Box" style={{ width: '16vw', margin: '0 auto', display: 'block' }} />
													<figcaption>Figure 5: Tail Gate Camera Mounting Assembly</figcaption>
												</figure>
											</div>
										</div>
									</div>
								</Tab>

								<Tab eventKey="Camera Assemblies" title="Camera Assemblies">
									<div class="tab-section" style={{ display: 'flex' }}>
										<div class="left-side" style={{ width: '40vw' }}>
											<h2>CAMERA ASSEMBLIES</h2>
											<p>Camera assemblies come in 35mm Focal Lengths. Each consists of a Teledyne Dalsa Genie Nano 5G camera with Fujinon 35mm lens, mounting bracket, transitional bracket, and boom for frame attachment and positioning. Each is numbered for clear identification.</p>
											<figure>
												<img src={AlliedVision} alt="Master Key Box" style={{ width: '35vw', margin: '20px' }} />
												<figcaption>Figure 1: Fujinon 35mm Lens & Dalsa Genie Nano 5G Camera</figcaption>
											</figure>
										</div>

										<div class="right-side">
											<figure>
												<img src={CameraAssembly} alt="Master Key Box" style={{ width: '40vw' }} />
												<figcaption>Figure 2: Camera Assembly Examples</figcaption>
											</figure>
										</div>
									</div>
								</Tab>

								<Tab eventKey="Lighting Assemblies" title="Lighting Assemblies">
									<div class="tab-section" style={{ display: 'flex' }}>
										<div class="left-side">
											<h2>LIGHTING ASSEMBLIES</h2>
											<p>The lighting Assemblies incorporate the single or double-width LED light source, 480W LED Driver, light bar clamps, transition bracket and boom, for attaching and positioning onto the frame assembly.</p>
											<div class="img-box" style={{ display: 'flex' }}>
												<figure style={{ width: '35vw' }}>
													<img src={Single600Lights} alt="Master Key Box" style={{ width: '100%' }} />
													<figcaption>Figure 1: 600 Single Width Light Assembly (Main Frame Inspect)</figcaption>
												</figure>
												<figure style={{ width: '45vw' }}>
													<img src={Double700Lights} alt="Master Key Box" style={{ width: '100%' }} />
													<figcaption>Figure 2: 600 Single Width Light Assembly (Tailgate Inspect)</figcaption>
												</figure>
											</div>
										</div>
									</div>
								</Tab>
							</Tabs>
						</content>
					</container>
				</wrapper>
			</main>
			<Footer />
		</>
	);
};

export default WarrenAssemblies;
